// jQuery plugins (select2, daterangepicker) resolve $ from window in the browser
// ESM bundle. Set it before importing those plugins (ESM runs imports in order).
import $ from 'jquery';

type WindowWithJq = Window & { $?: typeof $; jQuery?: typeof $ };
const w = window as WindowWithJq;
w.$ = w.jQuery = $;

// select2 / daterangepicker target jQuery 3 and call APIs removed in jQuery 4
// ($.isArray, $.isFunction, $.trim, $.type, …). Polyfill them so the plugins
// work regardless of the installed jQuery major version.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const jq = $ as any;
const toStr = Object.prototype.toString;
const class2type: Record<string, string> = {};
for (const name of ['Boolean', 'Number', 'String', 'Function', 'Array', 'Date', 'RegExp', 'Object', 'Error', 'Symbol']) {
  class2type[`[object ${name}]`] = name.toLowerCase();
}
jq.isArray ??= Array.isArray;
jq.isFunction ??= (o: unknown) => typeof o === 'function';
jq.isWindow ??= (o: unknown) => o != null && o === (o as Window).window;
jq.trim ??= (s: unknown) => (s == null ? '' : String(s).replace(/^[\s﻿\xA0]+|[\s﻿\xA0]+$/g, ''));
jq.now ??= Date.now;
jq.camelCase ??= (s: string) => s.replace(/-([a-z])/g, (_: string, c: string) => c.toUpperCase());
jq.nodeName ??= (el: { nodeName?: string } | null, name: string) =>
  !!el && (el.nodeName ?? '').toLowerCase() === name.toLowerCase();
jq.type ??= (o: unknown) => {
  if (o == null) return String(o);
  const t = typeof o;
  return t === 'object' || t === 'function' ? class2type[toStr.call(o)] || 'object' : t;
};

export {};
